import { render, staticRenderFns } from "./statsTable.vue?vue&type=template&id=fe21bc0c&scoped=true"
import script from "./statsTable.vue?vue&type=script&lang=js"
export * from "./statsTable.vue?vue&type=script&lang=js"
import style0 from "./statsTable.vue?vue&type=style&index=0&id=fe21bc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe21bc0c",
  null
  
)

export default component.exports